import { Map, Record } from 'immutable';

import CreditLine from './credit_line';
import { convertRawValues } from '../lib/utils/record_utils';

export default class CompanyRecord extends Record({
  id: null,
  name: '',
  underwriting_status: 'unknown',
  bank_verification_attempts: 0,
  applicant_fico_score: '',
  short_display: '',
  tier: '',
  credit_line: new CreditLine(),
  recharge_settings: [],
  products: [],
  naics_disclosure_agreement: false,
  min_rate: null,
  max_rate: null,
  is_bank_connected: false,
  is_bank_connected_via_plaid: false,
  active_cohorts_by_type: Map(),
  supports_virtual_card: null,
  vc_sub_limits: Map(),
}) {
  constructor(data) {
    data = convertRawValues(data);

    if (data.get('credit_line')) {
      data = data.set('credit_line', new CreditLine(data.get('credit_line')));
    }

    // Ensure active_cohorts_by_type is always a Map
    const cohorts = data.get('active_cohorts_by_type');
    if (cohorts != null && !Map.isMap(cohorts)) {
      data = data.set('active_cohorts_by_type', Map(cohorts));
    }

    const virtualCardSubLimits = data.get('vc_sub_limits');
    if (virtualCardSubLimits != null && !Map.isMap(virtualCardSubLimits)) {
      data = data.set('vc_sub_limits', Map(virtualCardSubLimits));
    }

    super(data);
  }

  setRechargeSettings(merchant_id, term) {
    const existingIndex = this.get('recharge_settings').findIndex((s) => {
      return s.get('merchant_id').toString() === merchant_id.toString();
    });

    return this.mergeIn(
      ['recharge_settings', existingIndex === -1 ? 1 : existingIndex],
      { default_term: term, merchant_id: merchant_id.toString() }
    );
  }
}
